import React from "react";
import PT from "prop-types";

import "./column.m.css";
import useUrl from "../../../hook/useUrl";
import SideBar from "../../molecules/sidebar";
import ColumnImg from "../../atoms/column-img";
import { Readpeak } from "../../atoms/readpeak";
import SocialShareBottom from "../social-share";
import AuthorInfo from "../../atoms/author-info";
import { Suurtaulu } from "../../atoms/suurtaulu";
import { SocialShare } from "@quintype/components";
import StoryHeaderNoImg from "../story-header-noimg";
import useSocialShareLinks from "../../../hook/useSocialShareLinks";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import StoryPaywallComponent from "../../atoms/paywalls/story-paywall-component";

const ColumnStory = ({ story }) => {
  const [_,currentUrlSlug]=useUrl();
  let domainSlug=""
  if(currentUrlSlug==="vaasa-lehti"){
    domainSlug="vaasa"
  }else{
    domainSlug="ilkka-pohjalainen"
  }
  const socialShareLinks= useSocialShareLinks(story,domainSlug);
  const metakeywords = story["seo"]["meta-keywords"];
  const hashtags = metakeywords ? metakeywords.map(item => {
    return item.replace(/ /g, "");
  }) : "";

  const storySections = story.sections;
  var section;
  var slug;

  if (storySections.find(section => section["domain-slug"] === "ilkka-pohjalainen")) {
    section = storySections.find(section => section["domain-slug"] === "ilkka-pohjalainen");
  }

  else if (storySections.find(section => section["domain-slug"] !== "undefined")) {
    section = story.sections[0];
  }

  if (section.collection === undefined) {
    slug = "";
  }// else {
   // slug = section.collection.slug;
 // }

  return (
    <React.Fragment>
      <div styleName="top-container">
        <div styleName="main-container">
          <div styleName="main">
            <div styleName="ad-container">
              <div styleName="mob-ad">
                <div id="sas_63333" data-placement-id="paraatipaikka-mobile"></div>
              </div>
              <div styleName="dsktop-ad">
                <div id="sas_63219" data-placement-id="paraatipaikka-desktop"></div>
              </div>
            </div>
            <div styleName="ad-container">
              <div styleName="mob-ad">
                <div id="sas_112313" data-placement-id="paraatipaikka-2-mobile"></div>
              </div>
              <div styleName="dsktop-ad">
                <div id="sas_112312" data-placement-id="paraatipaikka-2-desktop"></div>
              </div>
            </div>

          </div>
          <div styleName="column-story">
            <div styleName="sticky-social-share">
              <SocialShare
                template={StickySocialShareTemplate}
                story={story}
                title={story.headline}
                fullUrl={socialShareLinks}
                hashtags={story["seo"]["meta-keywords"] ? hashtags.join(",") : ""}
                color="#000"
                sticky
              />
            </div>
            <div className="voice-article" styleName="column-container">
              <div styleName="story-header">
                <StoryHeaderNoImg story={story} />
              </div>
              <div>
                <div styleName="author-img-wrapper">
                  <ColumnImg story={story} />
                </div>
                <div styleName="author-info-wrapper">
                  <AuthorInfo story={story} />
                </div>
                <div styleName="social-share-top">
                  <SocialShareBottom story={story} />
                </div>
              </div>
              <StoryPaywallComponent story={story} />
              <div styleName="readpeak-widget">
                <Readpeak />
              </div>
            </div>
            <SideBar useCollection={slug} pageType={"story"}/>
          </div>
        </div>
        <Suurtaulu />
      </div>
    </React.Fragment>
  );
}

ColumnStory.propTypes = {
  story: PT.object,
  isActive: PT.bool
};

export { ColumnStory };
